import { useEffect } from 'react'
import Popup from './Popup'
import ButtonSolid from './ButtonSolid'
import ButtonOutline from './ButtonOutline'

function UnsavedChangesPopup({ onStay, onLeave }) {

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onStay()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onStay])

  return (
    // The sidebar and navbar sit above the regular popup overlay, so lift this one over them.
    <div className='relative z-[10001]'>
      <Popup maxWidth='md:max-w-[500px]'>
        <div className='p-2'>
          <p className='text-lg font-semibold text-gray-700 mb-2'>Leave without saving?</p>
          <p className='text-sm text-gray-600 mb-5'>
            You have unsaved changes. If you leave this page now, your changes will be lost.
          </p>
          <div className='flex flex-col md:flex-row-reverse gap-4'>
            <ButtonSolid buttonText='Leave' onClick={onLeave} className='w-full' />
            <ButtonOutline buttonText='Stay' onClick={onStay} className='w-full' />
          </div>
        </div>
      </Popup>
    </div>
  )
}

export default UnsavedChangesPopup
